import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteStatusbar(uuid: string): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/notification/${uuid}`)
}
